// filepath: src/components/category-chip/styles.ts
import styled from "styled-components";
import { Chip } from "@mui/material";
import theme from "../../../../styles/theme";

export const StyledChip = styled(Chip)<{
  $selected: boolean;
  selectionType?: "primary" | "secondary";
}>`
  && {
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    font-size: 14px;
    border-radius: 20px;
    padding: 18px 12px;
    height: 40px;
    min-width: 150px;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    border: 1px solid transparent;
    cursor: pointer;

    ${({ $selected, selectionType }) => {
      if (!$selected) {
        return `
          background-color: #f1f3f4;
          color: #3c4043;
          &:hover {
            background-color: #e8eaed;
            border-color: #d2e3fc;
          }
        `;
      }
      if (selectionType === "primary") {
        return `
          background-color: ${theme.colors.blue.primary};
          color: white;
          &:hover {
            background-color: #3367D6;
          }
        `;
      }
      return `
        background-color: #34A853; // Verde Google
        color: white;
        &:hover {
          background-color: #2c8f45; // Verde mais escuro
        }
      `;
    }}

    &.Mui-disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;